import {Injectable} from '@angular/core';
import {
    AbweichenderOrtGeschaeftsleitungAngaben,
    Kommunikationsmittel,
    StammdatenAdresse,
    StammdatenUnternehmen
} from '@nachdigal';
import {AbstractMapper} from '../../abstract.mapper';
import {InlandsadresseMapperService} from './inlandsadresse-mapper.service';
import {AuslandsadresseMapperService} from './auslandsadresse-mapper.service';
import {isEqual} from 'lodash';
import {TelefonnummerMapperService} from './telefonnummer-mapper.service';
import { InternetadresseMapperService } from './internetadresse-mapper.service';
@Injectable()
export class AbweichenderOrtGeschaeftsleitungMapperService
    extends AbstractMapper<StammdatenUnternehmen, AbweichenderOrtGeschaeftsleitungAngaben> {

    constructor(
        private readonly inlandsadresseMapper: InlandsadresseMapperService,
        private readonly auslandsadresseMapper: AuslandsadresseMapperService,
        private readonly telefonnummerMapper: TelefonnummerMapperService,
        private readonly internetadresseMapper: InternetadresseMapperService
    ) {
        super();
    }

    private static isAbweichenderOrt(source: StammdatenUnternehmen): boolean {

        if (!source.geschaeftsleitungOrt) {
            return false;
        }
        if (!source.adressen) {
            return true;
        }
        // es ist ein abweichender Ort, wenn es keine Adresse gibt, die der GL-Adresse entspricht
        return source.adressen.filter(adresse => isEqual(adresse, source.geschaeftsleitungOrt)).length === 0;
    }

    protected mapInternal(source: StammdatenUnternehmen): AbweichenderOrtGeschaeftsleitungAngaben {
        if (!AbweichenderOrtGeschaeftsleitungMapperService.isAbweichenderOrt(source)) {
            return undefined;
        }

        return {
            inlandsadresse:
                source.geschaeftsleitungOrt.typ === StammdatenAdresse.TypEnum.NUMBER_0 ?
                    this.inlandsadresseMapper.map(source.geschaeftsleitungOrt) : null,
            auslandsadresse:
                source.geschaeftsleitungOrt.typ === StammdatenAdresse.TypEnum.NUMBER_1 ?
                    this.auslandsadresseMapper.map(source.geschaeftsleitungOrt) : null,
            kommunikationsmittel: this.mapKommunikationsmittel(source)
        };
    }

    private mapKommunikationsmittel(source: StammdatenUnternehmen): Kommunikationsmittel {
        if (!source || !source.geschaeftsleitungTelefon) {
            return null;
        }

        return {
            telefonnummern: this.telefonnummerMapper.mapArray([source.geschaeftsleitungTelefon]),
            internet: this.internetadresseMapper.mapArray(source.kommunikation?.internetadressen)
        };
    }
}
